import { useState, useEffect } from "react";
import * as sc from "../styled/scHeader";
import Logo from "../assets/logoYelken.png";
import { scrollTo } from "../animation";
import { FiMenu, FiX } from "react-icons/fi";
import MobileMenuPortal from "./MobileMenuPortal";

const Header = () => {
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Scroll olunca header'ı sticky hale getir
  const stickyHeaderFn = () => {
    const scrollY = window.scrollY;
    setSticky(scrollY >= 50);
  };

  useEffect(() => {
    document.addEventListener("scroll", stickyHeaderFn);
    return () => document.removeEventListener("scroll", stickyHeaderFn);
  }, []);

  // Hem scroll hem menüyü kapatma
  const go = (sectionId) => {
    scrollTo(sectionId);
    setMenuOpen(false);
  };

  return (
    <sc.HeaderWrapper sticky={sticky}>
      <sc.HeaderContainer>
        {/* Logo */}
        <sc.HeaderLogo src={Logo} alt="Yelken Otel Logo" />

        {/* MOBILE ICON (hamburger) */}
        <sc.MobileMenuIcon onClick={() => setMenuOpen(true)}>
          <FiMenu size={30} />
        </sc.MobileMenuIcon>

        {/* DESKTOP MENU */}
        <sc.HeaderButtonGroup>
          <sc.HeaderButton onClick={() => go("#home")}>
            Anasayfa
          </sc.HeaderButton>
          <sc.HeaderButton onClick={() => go("#gallery")}>
            Galeri
          </sc.HeaderButton>
          <sc.HeaderButton onClick={() => go("#surdurulebilirlik")}>
            Sürdürülebilirlik Politikası
          </sc.HeaderButton>
          <sc.HeaderButton onClick={() => go("#olanaklar")}>
            Olanaklar
          </sc.HeaderButton>
          <sc.HeaderButton onClick={() => go("#footer")}>
            İletişim
          </sc.HeaderButton>
        </sc.HeaderButtonGroup>
      </sc.HeaderContainer>

      {/* MOBİL MENÜ (PORTAL İLE BODY'YE ÇIKIYOR) */}
      {menuOpen && (
        <MobileMenuPortal>
          {/* Koyu arka plan */}
          <sc.MobileOverlay
            open={menuOpen}
            onClick={() => setMenuOpen(false)}
          />

          {/* Beyaz full-screen menü paneli */}
          <sc.MobileMenu open={menuOpen}>
            <sc.MobileClose onClick={() => setMenuOpen(false)}>
              <FiX />
            </sc.MobileClose>

            <sc.MobileMenuButton onClick={() => go("#home")}>
              Anasayfa
            </sc.MobileMenuButton>

            <sc.MobileMenuButton onClick={() => go("#gallery")}>
              Galeri
            </sc.MobileMenuButton>

            <sc.MobileMenuButton onClick={() => go("#surdurulebilirlik")}>
              Sürdürülebilirlik Politikası
            </sc.MobileMenuButton>

            <sc.MobileMenuButton onClick={() => go("#olanaklar")}>
              Olanaklar
            </sc.MobileMenuButton>

            <sc.MobileMenuButton onClick={() => go("#footer")}>
              İletişim
            </sc.MobileMenuButton>
          </sc.MobileMenu>
        </MobileMenuPortal>
      )}
    </sc.HeaderWrapper>
  );
};

export default Header;
